import { useMemo } from "react";
import { useShopNowV2CheckoutQuery } from "../../../gql/__generated__/schema";

const useCheckout = (token: string, code: string) => {
  const {
    data: checkoutResponse,
    loading: loadingCheckoutData,
    refetch: refetchCheckoutData,
  } = useShopNowV2CheckoutQuery({
    variables: {
      cartToken: token,
      code: code,
    },
  });

  const checkoutInfo = useMemo(() => {
    const data = checkoutResponse?.shopNowV2Checkout.data;
    return {
      checkoutData: data,
      paymentClientSecret: data?.payment?.paymentClientSecret ?? "",
      paymentRequired: (data?.overallCartSummary?.total?.amount || 0) > 0,
      discountCodeSaved: data?.overallCartSummary.discountCodes?.[0],
      paymentProcessorPubKey: data?.payment?.paymentProcessorPubKey ?? "",
      paymentNarvarRefId: data?.payment?.paymentRef ?? "",
      paymentProvider: data?.payment?.paymentProvider ?? "",
      paymentProcessorId: data?.payment?.paymentProcessorId ?? "",
    };
  }, [checkoutResponse]);

  return {
    checkoutResponse,
    loadingCheckoutData,
    refetchCheckoutData,
    ...checkoutInfo,
  };
};

export default useCheckout;
